import { Skeleton } from "@/components/ui/skeleton";

const CarbonInventorySkeleton = () => (
  <div className="space-y-6">
    <div className="grid gap-4 lg:grid-cols-2">
      <div className="rounded-radius border border-border bg-card p-5 shadow-sm">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="mt-2 h-3 w-72" />
      </div>
      <div className="rounded-radius border border-border bg-card p-5 shadow-sm">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="mt-2 h-10 w-full" />
        <Skeleton className="mt-2 h-3 w-32" />
      </div>
    </div>

    <div className="grid gap-4 lg:grid-cols-2">
      {Array.from({ length: 2 }).map((_, index) => (
        <div
          key={`carbon-scope-${index}`}
          className="space-y-4 rounded-radius border border-border bg-card p-6 shadow-sm"
        >
          <div className="flex items-center gap-3">
            <Skeleton className="h-10 w-10 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-3 w-48" />
            </div>
          </div>
          <div className="space-y-4">
            {Array.from({ length: 3 }).map((__, fieldIndex) => (
              <div key={`carbon-field-${index}-${fieldIndex}`}>
                <Skeleton className="h-4 w-48" />
                <Skeleton className="mt-2 h-10 w-full" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default CarbonInventorySkeleton;
